"use client";

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { useScrollReveal } from "@/hooks/use-scroll-reveal";
import { useSiteFlavor } from "@/components/layout/site-flavor-provider";
import posthog from "posthog-js";

export function LandingFooter() {
  const t = useTranslations("landing");
  const { brand, isGetmint } = useSiteFlavor();
  const ref = useScrollReveal<HTMLElement>({ animation: "fade-in" });
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-landing-border py-8" ref={ref}>
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-6 sm:flex-row">
        <div className="flex flex-col items-center gap-1 sm:items-start">
          <span className="text-sm text-landing-muted">
            &copy; {year} {brand.legalEntity}
          </span>
          {brand.legalAddress && (
            <span className="text-xs text-landing-muted/70">{brand.legalAddress}</span>
          )}
        </div>
        <div className="flex flex-wrap items-center justify-center gap-6">
          {isGetmint && (
            <Link
              href="/pricing"
              onClick={() => posthog.capture("landing_click", { element: "footer_pricing" })}
              className="text-sm text-landing-muted transition-colors hover:text-ink"
            >
              {t("footer.pricing")}
            </Link>
          )}
          {brand.supportChatUrl && (
          <a
            href={brand.supportChatUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => posthog.capture("landing_click", { element: "footer_telegram" })}
            className="text-sm text-landing-muted transition-colors hover:text-ink"
          >
            {t("footer.support")}
          </a>
          )}
          {brand.supportEmail && (
          <a
            href={`mailto:${brand.supportEmail}`}
            onClick={() => posthog.capture("landing_click", { element: "footer_email" })}
            className="text-sm text-landing-muted transition-colors hover:text-ink"
          >
            {brand.supportEmail}
          </a>
          )}
          <Link
            href="/privacy"
            onClick={() => posthog.capture("landing_click", { element: "footer_privacy" })}
            className="text-sm text-landing-muted transition-colors hover:text-ink"
          >
            {t("footer.privacy")}
          </Link>
          <Link
            href="/terms"
            onClick={() => posthog.capture("landing_click", { element: "footer_terms" })}
            className="text-sm text-landing-muted transition-colors hover:text-ink"
          >
            {t("footer.terms")}
          </Link>
          {isGetmint && (
            <Link
              href="/refund-policy"
              onClick={() => posthog.capture("landing_click", { element: "footer_refund_policy" })}
              className="text-sm text-landing-muted transition-colors hover:text-ink"
            >
              {t("footer.refundPolicy")}
            </Link>
          )}
        </div>
      </div>
    </footer>
  );
}
